module.exports = __webpack_public_path__ + "img/section_expenses.23f7889d.png";